import { lazy } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";

// Carga diferida (code-splitting): cada vista descarga su código solo cuando se visita.
const Home = lazy(() => import("@/pages/home/page"));
const ServicesPage = lazy(() => import("@/pages/services/page"));
const InstalacionesElectricasPage = lazy(() => import("@/pages/services/instalaciones-electricas-valls/page"));
const CuadrosBoletinesPage = lazy(() => import("@/pages/services/cuadros-electricos-boletines/page"));
const CuadrosElectricosPage = lazy(() => import("@/pages/services/cuadros-electricos/page"));
const BoletinesElectricosPage = lazy(() => import("@/pages/services/boletines-electricos/page"));
const IluminacionLEDPage = lazy(() => import("@/pages/services/iluminacion-led-eficiencia-energetica/page"));
const DomoticaPage = lazy(() => import("@/pages/services/domotica-automatizacion-hogar/page"));
const RecargaEVPage = lazy(() => import("@/pages/services/recarga-vehiculos-electricos/page"));
const AveriasUrgenciasPage = lazy(() => import("@/pages/services/averias-urgencias-electricas/page"));
const ElectricistaUrgentePage = lazy(() => import("@/pages/services/electricista-urgente/page"));
const ReformasElectricasPage = lazy(() => import("@/pages/services/reformas-electricas/page"));
const ComunidadesPropietariosPage = lazy(() => import("@/pages/services/comunidades-propietarios/page"));
const InstalacionesComercialesPage = lazy(() => import("@/pages/services/instalaciones-comerciales-industriales/page"));
const MantenimientoPage = lazy(() => import("@/pages/services/mantenimiento-electrico-preventivo/page"));
const ContactPage = lazy(() => import("@/pages/contact/page"));
const AboutPage = lazy(() => import("@/pages/about/page"));
const ServiceAreasPage = lazy(() => import("@/pages/service-areas/page"));
const ElectricistaVallsPage = lazy(() => import("@/pages/local/electricista-valls/page"));
const ElectricistaTarragonaPage = lazy(() => import("@/pages/local/electricista-tarragona/page"));
const ElectricistaReusPage = lazy(() => import("@/pages/local/electricista-reus/page"));
const ElectricistaMontblancPage = lazy(() => import("@/pages/local/electricista-montblanc/page"));
const ElectricistaElVendrellPage = lazy(() => import("@/pages/local/electricista-el-vendrell/page"));
const ElectricistaLaSelvaDelCampPage = lazy(() => import("@/pages/local/electricista-la-selva-del-camp/page"));
const ElectricistaAlcoverPage = lazy(() => import("@/pages/local/electricista-alcover/page"));
const ElectricistaCambrilsPage = lazy(() => import("@/pages/local/electricista-cambrils/page"));
const AdminLogin = lazy(() => import("@/pages/admin/login/page"));
const AdminPage = lazy(() => import("@/pages/admin/page"));
const BlogPage = lazy(() => import("@/pages/blog/page"));
const BlogArticleResolver = lazy(() => import("@/pages/blog/article/page"));
const NotFound = lazy(() => import("@/pages/NotFound"));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/servicios",
    element: <ServicesPage />,
  },
  // --- Redirects: URLs amigables → rutas canónicas ---
  {
    path: "/servicios/averias-y-mantenimiento",
    element: <Navigate to="/servicios/averias-urgencias-electricas" replace />,
  },
  {
    path: "/servicios/instalaciones-completas",
    element: <Navigate to="/servicios/instalaciones-comerciales-industriales" replace />,
  },
  {
    path: "/servicios/puntos-de-carga-vehiculos-electricos",
    element: <Navigate to="/servicios/recarga-vehiculos-electricos" replace />,
  },
  // --- Fin redirects ---
  {
    path: "/servicios/instalaciones-electricas-valls",
    element: <InstalacionesElectricasPage />,
  },
  {
    path: "/servicios/cuadros-electricos-boletines",
    element: <CuadrosBoletinesPage />,
  },
  {
    path: "/servicios/cuadros-electricos",
    element: <CuadrosElectricosPage />,
  },
  {
    path: "/servicios/boletines-electricos",
    element: <BoletinesElectricosPage />,
  },
  {
    path: "/servicios/iluminacion-led-eficiencia-energetica",
    element: <IluminacionLEDPage />,
  },
  {
    path: "/servicios/domotica-automatizacion-hogar",
    element: <DomoticaPage />,
  },
  {
    path: "/servicios/recarga-vehiculos-electricos",
    element: <RecargaEVPage />,
  },
  {
    path: "/servicios/averias-urgencias-electricas",
    element: <AveriasUrgenciasPage />,
  },
  {
    path: "/servicios/electricista-urgente",
    element: <ElectricistaUrgentePage />,
  },
  {
    path: "/servicios/reformas-electricas",
    element: <ReformasElectricasPage />,
  },
  {
    path: "/servicios/comunidades-propietarios",
    element: <ComunidadesPropietariosPage />,
  },
  {
    path: "/servicios/instalaciones-comerciales-industriales",
    element: <InstalacionesComercialesPage />,
  },
  {
    path: "/servicios/mantenimiento-electrico-preventivo",
    element: <MantenimientoPage />,
  },
  {
    path: "/blog",
    element: <BlogPage />,
  },
  {
    path: "/blog/:slug",
    element: <BlogArticleResolver />,
  },
  {
    path: "/contacto",
    element: <ContactPage />,
  },
  {
    path: "/sobre-nosotros",
    element: <AboutPage />,
  },
  {
    path: "/zona-de-servicio",
    element: <ServiceAreasPage />,
  },
  {
    path: "/electricista-valls",
    element: <ElectricistaVallsPage />,
  },
  {
    path: "/electricista-tarragona",
    element: <ElectricistaTarragonaPage />,
  },
  {
    path: "/electricista-reus",
    element: <ElectricistaReusPage />,
  },
  {
    path: "/electricista-montblanc",
    element: <ElectricistaMontblancPage />,
  },
  {
    path: "/electricista-el-vendrell",
    element: <ElectricistaElVendrellPage />,
  },
  {
    path: "/electricista-la-selva-del-camp",
    element: <ElectricistaLaSelvaDelCampPage />,
  },
  {
    path: "/electricista-alcover",
    element: <ElectricistaAlcoverPage />,
  },
  {
    path: "/electricista-cambrils",
    element: <ElectricistaCambrilsPage />,
  },
  {
    path: "/admin/login",
    element: <AdminLogin />,
  },
  {
    path: "/admin",
    element: <AdminPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;